import { REACT_APP_HOST_URL } from '../../env'

export const ACCESS_TOKEN = 'access_token'
export const ID_TOKEN = 'id_token'
export const EXPIRES_AT = 'expires_at'

export const AUTH_CONFIG = {
  domain: 'q4inc.auth0.com',
  clientId: 'Fwkzq559mlf2ulimnmun7zk7wTRixlPN',
  callbackUrl: REACT_APP_HOST_URL
}
